import { Component, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { NgClass } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { DataLayersService } from 'src/app/core/services/data-layers.service';
import { SesionService } from 'src/app/core/services/sesion.service';
import { environment } from 'src/environments/environment';
import { LazyLoadImgDirective } from 'src/app/core/directives/lazy-load-img.directive';
import { UiAccordionItemMoleculeComponent } from 'src/app/shared/ui/molecules/ui-accordion-item/ui-accordion-item.component';

declare const $: any;

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: [NgClass, RouterLink, LazyLoadImgDirective, UiAccordionItemMoleculeComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true

})

export class FooterComponent implements OnInit {
  linkMIDC = environment.urlMIDC
  url_politica_privacidad = environment.enlaces_cloudFront.url + environment.enlaces_cloudFront.politica_privacidad;
  url_terminos_condiciones = environment.enlaces_cloudFront.url + environment.enlaces_cloudFront.terminos_condiciones;
  anio = new Date().getFullYear();
  public footerPay = false;
  public showDisclaimer = false;
  readonly openSections = signal<boolean[]>([false, false, false]);

  constructor(
    public sesion: SesionService,
    private readonly router: Router,
    private readonly dataLayerService: DataLayersService) { }

  ngOnInit() {
  }
  // ngAfterContentChecked () {
  //   this.showDisclaimer = this.utilities.isComponentRender('HomeComponent');
  // }

  verifyUrl() {
    this.footerPay = false;
    if (this.router.url == "/pago") {
      this.footerPay = true;
    }
    return "ok-url";
  }

  scrollPlanes() {
    $('html, body').animate({
      scrollTop: $('#planesPreId').offset().top
    }, 1000);
  }
  scroll() {
    let planSel = document.querySelector('#planesPreId');
    if (planSel != null) {
      planSel.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  showBodylinks(ele: number, event: Event) {
    const sections = this.openSections();
    const updated = [...sections];
    updated[ele] = !updated[ele];
    this.openSections.set(updated);
    this.clic_footer_menu(event);
  }

  /**
   * Esta función envia un data layer de GA4 "clic_footer_menu" por cada opción que el usuario elija.
   * @param producto Variable en donde se almacena la opción seleccionada por el usuario.
   */
  clic_footer_menu(event: Event) {
    let textEvent = (event.target as HTMLElement).innerText;
    if (textEvent == '') {
      let container = event.currentTarget as HTMLElement;
      let parrafo = container.querySelector('p');
      textEvent = parrafo?.innerText || '';
    }
    this.dataLayerService.dl_eventoGA4_menu('clic_footer_menu', `${this.normalizeText(textEvent)} | Footer`);
  }

  irServicioCliente() {
    window.location.href = this.linkMIDC + 'servicio-cliente';
  }

  /**
   * Funcion que quita las tildes de un string
   * 
   * @param text 
   * @returns 
   */
  normalizeText(text: string): string {
    return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
  }

  clic_footer_download_app() {
    let event = {
      'event': 'ga_event',
      'name_event': 'clic_footer_download_app'
    }
    this.dataLayerService.dl_event(event);
  }

}